module.exports = {"610825001":"定边街道","610825101":"贺圈镇","610825102":"红柳沟镇","610825103":"砖井镇","610825104":"白泥井镇","610825105":"安边镇","610825106":"堆子梁镇","610825107":"白湾子镇","610825108":"姬塬镇","610825109":"杨井镇","610825110":"新安边镇","610825111":"张崾先镇","610825112":"樊学镇","610825113":"盐场堡镇","610825114":"郝滩镇","610825115":"石洞沟镇","610825116":"冯地坑镇","610825204":"油房庄乡","610825210":"学庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610825.json
// module id = 3003
// module chunks = 0